







































import { Component, Prop, Vue } from "vue-property-decorator";
import ReadyAttemptModel from "@/model/ReadyAttemptModel";
import AttemptModule from "@/store/AttemptModule";

@Component
export default class StartedAttempt extends Vue {
  @Prop()
  attempt!: ReadyAttemptModel;

  startAttempt() {
    AttemptModule.startAttempt(AttemptModule.uuid);
  }

  get isPublic() {
    return this.attempt.public;
  }
}
